export const updateAtIndex = <A>(array: A[], newValue: A, index: number) => [...array.slice(0, index), newValue, ...array.slice(index + 1)];
